import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Newsletter from '../endpoints/Newsletter/page';
import {
  fetchMemberDriveStatus,
  addMemberDriveElements,
} from '../utils/membershipUtils';
// import adCleanup from '../utils/adCleanup';

/* eslint react/display-name: 0 */

export const getServerSideProps = () => {
  const layout = 'default';
  return {
    props: {
      layout,
    },
  };
};

const NewsletterPage = ({ errorCode }) => {
  if (errorCode) return <ErrorPage statusCode={errorCode} />;

  useEffect(() => {
    fetchMemberDriveStatus().then((data) => {
      addMemberDriveElements(data);
    });
  }, []);

  return <Newsletter />;
};

NewsletterPage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default NewsletterPage;
